// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1GNEZ","list":"styles_list__3lIu3"};